import { FieldPolicy } from '@apollo/client';

export const mediaLibraryMergePolicy = (): FieldPolicy => {
  return {
    keyArgs: ['$context'],
    merge(existing, incoming = [], { readField }) {
      const merged = [...(existing?.items || []), ...(incoming?.items || [])];

      // Remove duplicates.
      for (let i = 0; i < merged.length; i++) {
        if (merged.find((el, idx) => idx !== i && JSON.stringify(el) === JSON.stringify(merged[i]))) {
          merged.splice(i, 1);
          i--;
        }
      }

      // Sort by newest date uploaded.
      merged.sort((el1, el2) => {
        const date1 = new Date(readField('dateUploaded', el1) as string).getTime();
        const date2 = new Date(readField('dateUploaded', el2) as string).getTime();
        return date2 - date1;
      });

      return {
        ...incoming,
        items: merged
      };
    }
  };
};

export const findImagesSearchMergePolicy = (): FieldPolicy => {
  return {
    keyArgs: false,
    merge(existing, incoming) {
      return existing ? [...existing, ...incoming] : incoming;
    }
  };
};
